import { fromJS, Map } from "immutable";

import actionTypes from "../../../action-types";
import ContentModule from "../../../models/state/modules/module/ContentModule";
import { Modules } from "../../../models/state/modules/Modules";

export default function modulesReducer(
  contentModules: Modules = Map<string, ContentModule>(),
  action: Record<string, any>
) {
  switch (action.type) {
    case actionTypes.ADD_COURSE: {
      const course = action.payload.course;
      return contentModules.merge(flattenContentModules(course));
    }

    case actionTypes.ADD_SECTION: {
      return contentModules.merge(
        flattenContentModules(action.payload.section)
      );
    }

    default:
      return contentModules;
  }
}

export function flattenContentModules(course: Record<string, any>) {
  return flattenSectionContentModules(Map<string, ContentModule>(), course);
}

function flattenSectionContentModules(
  contentModules: Modules,
  section: Record<string, any>
) {
  if (section.contents) {
    section.contents.forEach((content: any) => {
      content.contentModules.forEach((contentModule: any) => {
        const { id, content, ...rest } = contentModule;
        contentModules = contentModules.set(
          id,
          new ContentModule({
            id,
            ...rest,
            content: fromJS(content)
          })
        );
      });
    });
  }

  if (section.sections) {
    for (const sectionId in section.sections) {
      contentModules = contentModules.merge(
        flattenSectionContentModules(
          contentModules,
          section.sections[sectionId]
        )
      );
    }
  }

  return contentModules;
}
